"use client";

import BottomSheet from "../BottomSheet";
import { ARROW_ICON, STEPS } from "./howItWorksContent";
import StepIcon from "./StepIcon";

interface HowItWorksModalProps {
  isOpen: boolean;
  onClose: () => void;
}

/** One step row: the icon column on the left, title and description on the right. */
function ModalStep({ index }: { index: number }) {
  const { title, description, icon } = STEPS[index];
  const isLast = index === STEPS.length - 1;

  return (
    <div className="flex items-start w-full gap-2">
      {/* self-stretch + justify-between drops the chevron to the bottom of the row,
          however tall the description grows. */}
      <div className="flex flex-col items-center justify-between self-stretch shrink-0 w-8">
        <StepIcon src={icon} step={index + 1} />
        {!isLast && <img src={ARROW_ICON} alt="" aria-hidden="true" className="block w-3 h-3 rotate-90" />}
      </div>

      <div className="flex flex-col flex-1 min-w-0 gap-1">
        <div className="text-[13px] font-bold leading-[18px] text-dark-1">{title}</div>
        <p className="text-xs font-medium leading-4 tracking-[0] text-gray-1">{description}</p>
      </div>
    </div>
  );
}

/**
 * The mobile "how it works" sheet, opened by the hero explainer's "Find out
 * more" link. The page mounts it — see BottomSheet for why.
 */
export default function HowItWorksModal({ isOpen, onClose }: HowItWorksModalProps) {
  return (
    <BottomSheet
      isOpen={isOpen}
      title="HOW IT WORKS"
      onClose={onClose}
      footer={
        <button
          type="button"
          onClick={onClose}
          className="flex items-center justify-center w-full h-12 px-4 text-base font-medium leading-5.5 text-white bg-primary rounded hover:bg-primary/90 transition-colors">
          GOT IT — SHOW ME THE PRIZES
        </button>
      }>
      <div className="flex flex-col w-full gap-4">
        {STEPS.map(({ title }, index) => (
          <ModalStep key={title} index={index} />
        ))}
      </div>
    </BottomSheet>
  );
}
